import { render, staticRenderFns } from "./NovelCreatePage.vue?vue&type=template&id=0b692abe&"
import script from "./NovelCreatePage.vue?vue&type=script&lang=ts&"
export * from "./NovelCreatePage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports